// * Import 3rd party lib
import { styled, useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router";

// * Import Kit
import Box from "../../kit/Box";

// * Define required styled components
const Root = styled(Box)(({ theme }) => ({
  overflow: "hidden",
  height: theme.size[33] /* You must set a specified height */,
  backgroundPosition: "center" /* Center the image */,
  backgroundRepeat: "no-repeat" /* Do not repeat the image */,
  backgroundSize:
    "contain" /* Resize the background image to cover the entire container */,
  display: "inline-block",
}));

function Logo(props = {}) {
  const navigate = useNavigate();
  const theme = useTheme();
  return (
    <Root className="logo" sx={{ display: "flex", alignItems: "center" }}>
      <Box
        component="img"
        alt="Logo"
        src={props.logo}
        sx={{ height: theme.size[45], cursor: "pointer" }}
        onClick={() => {
          navigate("/discover");
        }}
      />
    </Root>
  );
}

export default Logo;
